// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"styles_formWrapper__3ioDe","inputWrapper":"styles_inputWrapper__FD6t7","buttonsWrapper":"styles_buttonsWrapper__xsVV7"};